<template>
<div :class="modalClass" class="modal-card">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <header class="modal-card-head" v-if="!onContentViewer">
        <div class="column is-one-third share-link-column">
            <button @click="createLink()" class="button is-success is-medium">
                <p>Share</p>
            </button>
        </div>
        <div class="column link-right-column" v-show="isCollapsed !=true">
            <P class="link-expire-message">This link will expire on {{ shareLinkExpirationDate }}.</P>
            <b-field class="link-field">
                <b-input class="grow share-link-input" id="share-link-field" v-model="link" size="is-small" readonly></b-input>
                    <p class="control">
                        <button class="button is-success copy-button" @click="copyLink()">
                            <p>Copy Link</p>
                        </button>
                    </p>
             </b-field>
        </div>
        <button v-if="showCloseButton" class="button is-clear close-button" @click="emitClose">X</button>
    </header>
    <div v-if="hasError && onContentViewer && !isLoading" class="error-body">
       <p class="error-message">
           {{ errorMessage }}.
        </p> 
    </div>
    <div v-else-if="!isLoading && !isDownloadOnly" class="fullscreen-container" id="fullscreen-body">
        <div id="modal-body" :class="modalBodyClass">
        <iframe style="overflow:hidden" scrolling="no" :src="iframeURL" id="contentIframe"></iframe>
        <iframe style="visibility:hidden" :src="this.packageDocument.filePath" id="printIframe"></iframe>
        </div>
        <footer class="modal-card-footer">
            <div class="columns content-options" v-if="!isMobile">
                <div class="column is-half download-column">
                    <a :href="this.packageDocument.filePath" :download="this.packageDocument.fileName"><button v-if="isDownloadable == true" class="button is-success is-small footer-button" @click="countDownload">Download</button></a>
                    <button v-if="!isDownloadOnly && isPrintable == true" class="button is-success is-small footer-button" @click="printIframeContent()">Print</button>
                </div>
                <div class="column is-half download-column">
                    <button v-if="this.isMobile !=true" class="button is-clear is-small no-border float-right fullscreen-button" @click="onFullscreen()"><b-icon pack="fas" icon="arrows-alt"></b-icon></button>
                </div>
            </div>
            <div v-else>
                <a :href="this.packageDocument.filePath" :download="this.packageDocument.fileName"><button v-if="isDownloadable == true" class="button is-success is-small footer-button" @click="countDownload">Download</button></a>
                <button v-if="!isDownloadOnly && isPrintable == true" class="button is-success is-small footer-button" @click="printIframeContent()">Print</button>
            </div>
        </footer>



    </div>
</div>
</template>

<script>
import sharedAPI from '@/api/SharedAPI.js'
import { mapState, mapMutations} from 'vuex'
import store from '../store.js'
import axios from 'axios'


export default {
    name: 'ContentViewer',

    props: {
        _document: Object,
    }, 

    data(){
        return{
            isLoading: false,
            isCollapsed: true,
            isFullPage: true,
            link: null,
            isCopied: false,
            packageDocument: {},
            hasError: false,
            errorMessage: null,
            errorCode: null,
            isDownloadable: false,
            isPrintable: false,
            isMobile: false,
            isFullScreen: false,
            downloadOnlyDataType: ["pptx", "avi", "docx", "doc", "xls", "xlsx", "mp4", "mp3", "wav", "flv", "mpeg", "mpv"],
            shareLinkExpirationDate: '',
        }
    },

    created(){
       if( this.$route.name == "contentViewer" ){
           //USE FUNCTION TO LOAD DOCUMENT
           if(this.sharedDocument){
               this.packageDocument = this.sharedDocument
           }
           else{
               this.loadDocument()
           }
        }
        else if(this.$route.name == "mobileContentViewer"){
            this.isMobile = true;
            if(this.foundDocument){
                this.packageDocument = this.foundDocument
            }
            else{
                this.loadMobileDocument()
            }
        }
        else{
            //USE PROP TO LOAD DOCUMENT
            this.packageDocument = this._document
            this.isDownloadable = this.packageDocument.isDownloadable
            this.isPrintable = this.packageDocument.isPrintable
        } 



    },

    computed: {
        ...mapState([
            'userInfo',
            'sharedDocument',
            'linkExpirationDate'
        ]),


        viewType: function(){
            if(this.packageDocument.fileExt == "pdf"){
                return "viewPDF";
            }
            else{
                return "iframe";
            }
        },


        onContentViewer: function(){
            return this.$route.name == "contentViewer"
        },


        base64Image: function(){
            return "data:image/jpg;base64, " + this.packageDocument.base64
        },


        locationURL: function(){
            if(window.location.hostname == 'localhost' ){
                return "http://localhost:8888/woodburn-unlimited/api/v1/"
            }
            else{
                return window.location.origin + "/api/v1/"
            }
        },


        pdfViewScale: function(){
            if(this.isMobile == true){
                return .75
            }
            else{
                return 1
            }
        },


        iframeURL: function(){
            return this.locationURL + this.viewType + ".php?filepath=" + this.packageDocument.filePath + "&scale=" + this.pdfViewScale;
        },


        hiddenIframeURL: function(){
            return this.locationURL + "iframe.php?filepath=" + this.packageDocument.filePath;           
        },


        modalClass: function(){
            if (this.isDownloadOnly == true && this.contentWindow){
                return "modal-fit-content"
            }
            else if(this.isMobile == true){
                return "mobile-card"
            }
            else if(this.onContentViewer){
                return "modal-full-height"
            }
            else if (this.isDownloadOnly == true){
                return "modal-small"
            }
            else{
                return "modal-card"
            }
        },


        modalBodyClass: function(){
            if (this.onContentViewer && this.isDownloadOnly == true){
                return "modal-hidden"
            }
            else if(this.onContentViewer){
                return "modal-fullbody-height"
            }
            else{
                return "modal-card-body"
            }
        },


        isDownloadOnly: function(){
            if(this.downloadOnlyDataType.includes(this.packageDocument.fileExt) == true){
                return true
            } 
            else{
                return false
            }
        },


        showCloseButton: function(){
            if(this.isMobile == true){
                return true
            }
            else{
                return false
            }
        }
    },

    methods:{
        /**
         * TO CREATE AND DISPLAY THE WOODBURN SHARE LINK RECORD
         **/
        createLink: async function(){
            var scriptParameters = `{
                "accountID" : "${this.userInfo.accountID}",
                "documentID" : "${this.packageDocument.ID}",
                "packageID" : "${this.packageDocument.packageID}",
                "loginID" : "${this.userInfo.userID}",
                "urlOrigin" : "${window.location.origin}"
            }`

            console.log(scriptParameters)
            const result = await sharedAPI.runScript("Woodburn Plus Share Link - Create Link", scriptParameters)
            console.log(result)
            var scriptResult = JSON.parse(result.response.scriptResult)

            //TOKEN error
            if(result.messages[0].code == 401){
                $route.replace({name:"logout"})
            }
            //FM error
            if(result.messages[0].code != "0"){
                this.$snotify.error( scriptResult.messages[0].message, "Error",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                )
                return
            }
            //Script error 
            if(scriptResult.code != 0){
                this.$snotify.error( scriptResult.message, "Error",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                )
                return
            }
            //Success
            this.isCopied = false;
            this.link = scriptResult.result
            this.shareLinkExpirationDate = scriptResult.expirationDate
            if (this.isCollapsed != false){
                this.isCollapsed = !this.isCollapsed
            }

            this.copyLink()
        },


        /**
         * FUNCTION TO FIND DOCUMENT BASED ON LINK
         */
        loadDocument: async function(){
            this.isLoading = true
            var linkID = this.$route.params.linkID
            var scriptParameters = {
                 linkID : linkID,
            }
            var scriptParameters = JSON.stringify(scriptParameters)
            const result = await sharedAPI.loadSharedDocument(scriptParameters)
            var scriptResult = JSON.parse(result.response.scriptResult)
            //FM error
            if(result.messages[0].code !== "0"){
               this.errorMessage = result.messages[0].message
               this.errorCode = result.messages[0].code
               this.hasError = true
               this.isLoading = false
               return
            }  

            // Script error
            if(scriptResult.code != 0){
                this.errorMessage = scriptResult.message
                this.errorCode = scriptResult.code
                this.hasError = true
                this.isLoading = false
                return
            }

            //Success
            var loadedDocument = scriptResult.result
            this.packageDocument = loadedDocument
            this.hasError = null
            this.errorMessage = null
            this.isLoading = false
        },


        
        /**
         * LOAD DOCUMENT FROM MOBILE WEBSITE, MOBILE GOES TO COMPONENET INSTEAD OF OPENING IT IN A MODAL WINDOW
         */
        loadMobileDocument: async function(){
            this.isLoading = true
            var documentID = this.$route.params.documentID
            var scriptParameters = {
                 documentID : documentID,
            }
            var scriptParameters = JSON.stringify(scriptParameters)
            const result = await sharedAPI.loadMobileDocument(scriptParameters)
            var scriptResult = JSON.parse(result.response.scriptResult)
            //FM error
            if(result.messages[0].code !== "0"){
               this.errorMessage = result.messages[0].message
               this.errorCode = result.messages[0].code
               this.hasError = true
               this.isLoading = false
               return
            }  
            // Script error
            if(scriptResult.code != 0){
                this.errorMessage = scriptResult.message
                this.errorCode = scriptResult.code
                this.hasError = true
                this.isLoading = false
                return
            }
            //Success
            var foundDocument = scriptResult.result
            this.packageDocument = foundDocument
            this.hasError = null
            this.errorMessage = null
            this.isLoading = false
            this.isDownloadable = this.packageDocument.isDownloadable
            this.isPrintable = this.packageDocument.isPrintable
        },


        
        /**
         * FUNCTIONS TO COPY LINK
         */
        copyLink: function(){

            var success = true;
            if (window.clipboardData) { // Internet Explorer
                window.clipboardData.setData ("Text", this.link);
            }
            else {
                    // create a temporary element for the execCommand method
                var forExecElement = this.CreateElementForExecCommand (this.link);

                        /* Select the contents of the element 
                            (the execCommand for 'copy' method works on the selection) */
                this.SelectContent (forExecElement);

                var supported = true;

                    // UniversalXPConnect privilege is required for clipboard access in Firefox
                try {
                    if (window.netscape && netscape.security) {
                        netscape.security.PrivilegeManager.enablePrivilege ("UniversalXPConnect");
                    }

                        // Copy the selected content to the clipboard
                        // Works in Firefox and in Safari before version 5
                    success = document.execCommand ("copy", false, null);
                }
                catch (e) {
                    success = false;
                }
                
                    // remove the temporary element
                document.body.removeChild (forExecElement);

                this.$snotify.success( "Link Copied!", "Share",
                        {
                            showProgressBar: false,
                            position: 'centerTop',
                            icon: false,
                            timeout: 4000,
                            closeOnClick: true,
                            bodyMaxLength: 1000,
                            pauseOnHover: false,
                        }
                    )
                this.isCopied = true
            }
        },


        /**
         * COPIES TEXT TO THE CLIPBOARD
         */
        CreateElementForExecCommand: function (textToClipboard) {
            var forExecElement = document.createElement ("div");
                // place outside the visible area
            forExecElement.style.position = "absolute";
            forExecElement.style.left = "-10000px";
            forExecElement.style.top = "-10000px";
                // write the necessary text into the element and append to the document
            forExecElement.textContent = textToClipboard;
            document.body.appendChild (forExecElement);
                // the contentEditable mode is necessary for the  execCommand method in Firefox
            forExecElement.contentEditable = true;

            return forExecElement;
        },


        /**
         * SELECTS CONTENT TO SAVE TO CLIPBOARD
         */
        SelectContent: function (element) {
                // first create a range
            var rangeToSelect = document.createRange ();
            rangeToSelect.selectNodeContents (element);

                // select the contents
            var selection = window.getSelection ();
            selection.removeAllRanges ();
            selection.addRange (rangeToSelect);
        },


        /**
         * PRINTS CONTENT IN IFRAME
         */
        printIframeContent: function(){
            this.countPrint();
            var frame = parent.document.getElementById("printIframe").contentWindow;
            frame.focus();
            frame.print();
            
        },


        /**
         * TOGGLES FULLSCREEN
         */
        onFullscreen: function(){
            var elem = document.getElementById("fullscreen-body");

            if(this.isFullScreen == false){
                console.log("hey, caught in fullscreen")
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen) { /* Firefox */
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE/Edge */
                    elem.msRequestFullscreen();
                }
            }
            else{
                console.log("hey, caught in not fullscreen")
                if (document.fullsreenElement) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) { /* Firefox */
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE/Edge */
                    document.msExitFullscreen();
                }
            }

            this.isFullScreen = !this.isFullScreen
        },


        /**
         * CLOSES MODAL WINDOW
         */
        emitClose: function(){
            this.$router.push({name: 'home'})
        },


        /**
         * ADDS A COUNT TO THE NUMBER OF DOWNLOADS FOR THE USER
         */
        countDownload: async function(){
            var scriptParameters = `{
                "counterType" : "download",
                "userID": "${this.userInfo.userID}"
            }`;

            const result = sharedAPI.runScript("User - Update Counters", scriptParameters)
        },


        /**
         * ADDS A COUNT TO THE NUMBER OF PRINTS FOR THE USER
         */
        countPrint: async function(){
            var scriptParameters = `{
                "counterType" : "print",
                "userID": "${this.userInfo.userID}"
            }`;

            const result = sharedAPI.runScript("User - Update Counters", scriptParameters)
        }

    }
}

</script>

<style scoped>
    iframe{
        width: 100% !important;
        height: 100% !important;
    }
    .close-button{
        float:right;
    }
    .button{
    margin: auto;
    text-align: center;
    }
    .button:focus{
        outline: 0 !important;
    }
    .content-options{
        padding: 5px 5px 5px 5px;
        width: 100%;
        margin: 0px !important;
    }
    .copy-button{
        height: 27px;
        line-height: 12px;
        
    }
    .download-column{
        padding: 0px;
        padding-left: 5px;
        margin: 0px !important;
        display: inline;
    }
    .download-only{
        padding-bottom: 35px !important;
        width: 100%;
        display: inline-block;
        vertical-align: middle;
    }
    .error-body{
        width: 100%;
        height: 100%;
        background-color: #EEEEEE;
    }
    .error-message{
        text-align: center;
        size: 24px;
    }
    .float-right{
        float: right;
    }
    .fullscreen-container{
        height: 100%;
    }
    .grow{
        flex-grow: 1;
        width: 250px;
    }
    .is-clearfix{
        width: 150px !important;
    }
    .share-link-input{
        max-width: 82% !important;
        width: 82% !important;
    }
    .link-expire-message{
        padding-top: 6.5px;
        font-size: .75rem;
    }
    .link-right-column{
        padding: 0px;
        padding-top: 5px;
        height: 60px;
        width: 61%;
    }
    .modal .animation-content .modal-small {
        margin: 0;
        height: auto;
    }
    .modal-card{
    background-color:  #a8a8a8 !important;
    width:960px;
    height:800px;
    overflow:hidden !important;
    padding: 0px;
    }
    .modal-card-body{
    overflow:hidden !important;
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    height: 94.5%;
    }
    .modal-card-footer{
        border-top: 1px solid !important;
        border-top-color: #d4d0d0 !important;
        background-color: #ffffff !important;
        padding: 0px;
        height: 35px;
    }
    .modal-card-head{
        background-color:  #ffffff !important;
        padding: 0px;
        padding-bottom: 5px;
        height: 75px;
    }
    .modal-full-height{
        background-color:  #a8a8a8 !important;
        width:1200px;
        overflow:hidden !important;
        padding: 0px;
        height: 102% !important;
        margin: auto;
    }
    .modal-fullbody-height{
        height: 100% !important;
    }
    .modal-hide-body{
        display: none;
    }
    .modal-hidden{
        display: none;
        visibility: hidden;
    }
    .modal-small{
        width:450px;
        height:auto;
        padding: 0px;
        overflow:hidden !important;
        background-color:  #a8a8a8 !important;
    }
    .modal-fit-content{
        height: fit-content;
    }
    .no-border{
        border: 0px
    }
    .pdf-viewer{
        width: 100% !important;
        height: 100% !important;
    }
    .share-form-left{
        width: 15% !important;
        height: 25px !important;
        padding-right: 5px;
        margin: 0px;
    }
    .share-form-right{
        flex-grow: 1;
        height: 55px !important;
    }
    .share-link{
        width: 80%;
        height: 20px;
        border: solid;
        border-width: 1px;
    }
    .share-link-column{
        padding: 0px;
        padding-left: 5px;
        padding-top: 5px;
        height: 60px
    }
    .footer-button{
        margin-left: 5px;
    }
    .mobile-card{
        margin: 0px;
    }

    @media screen and (max-width: 960px ){
        .modal-card{
            width: 100%;
        }
        .fullscreen-container{
            height: 85%
        }
        .modal-card-footer{
            border-top: 1px solid !important;
            border-top-color: #d4d0d0 !important;
            background-color: #ffffff !important;
            padding: 0px;
            height: 150px;
        }
        .content-options{
            padding: 0px;
            width: 100%;
            margin: 0px !important;
        }
    }

</style>